let ready = false;
let loading_script = false;

export function load_swiper_check(){
    if( !window.load_swiper ) return;
    load_swiper_init();
}

export function load_swiper_init(on_ready){

    if( typeof Swiper !== 'undefined' ) {
        
        swiper_ready();

        if( typeof on_ready === 'function' ) {
            on_ready();
        }

        return;
    }

    if( has_elementor_swiper_elements() ) {
        check_elementor_swiper_ready(on_ready);
    }
    else {
        load_swiper_script();
    }
}

function has_elementor_swiper_elements(){
    return document.querySelector('.elementor-swiper') ? true : false;
}

function load_swiper_script(){

    if( loading_script ) return;
    loading_script = true;

    const script = document.createElement('script');
    script.src = window.location.origin+'/wp-content/plugins/elementor/assets/lib/swiper/v8/swiper.min.js?ver=8.4.5';
    script.onload = swiper_ready;
    document.body.appendChild(script);
}

function swiper_ready(){
    if( ready ) return;
    ready = true;
    document.dispatchEvent(new Event('swiper_ready'));
}

function check_elementor_swiper_ready(on_ready){

    if( typeof Swiper !== 'undefined' ) {

        swiper_ready();

        if( typeof on_ready === 'function' ) {
            on_ready();
        }

        return;
    }

    const checker = setInterval(function(){
        if( typeof Swiper !== 'undefined' ) {
            clearInterval(checker);
            swiper_ready();
        }
    }, 50);
}